import React, { useState } from 'react'
import { Badge, Grid } from 'antd-mobile'
import { DownOutline } from 'antd-mobile-icons'
import Icon from '../../../icon'

const LIVE_MATCH_TABS = [
    { value: 'game', label: '赛场', icon: Icon.JERSEY },
    { value: 'live', label: '实况', icon: Icon.CAIPAN_SHAOZI },
    { value: 'dinner', label: '聚餐', icon: Icon.DINNER_ICON }
]

// 顶部页签的可用状态由比赛数据决定，切换状态仍由主页面统一管理。
export const LiveMatchTabs = ({ activeTab, onChange, hasGame }) => (
    <div className="premium-tab-switcher" role="tablist" aria-label="比赛页面切换">
        {LIVE_MATCH_TABS.map((tab) => (
            <button
                key={tab.value}
                className={`premium-tab-btn ${activeTab === tab.value ? 'active' : ''}`}
                onClick={() => onChange(tab.value)}
                disabled={tab.value === 'dinner' && !hasGame}
                role="tab"
                aria-selected={activeTab === tab.value}
            >
                <img src={tab.icon} style={{ width: '18px' }} alt="" />
                <span>{tab.label}</span>
            </button>
        ))}
    </div>
)

// 球场只接收已经计算好的阵容节点和统计值，不参与比赛数据修改。
export const LivePitchBoard = ({ gameDetail, getModelContent, greenLineup, redLineup, greenStats, redStats }) => (
    <div className="live-pitch-board" style={{ position: 'relative', width: '100%', height: '800px', color: '#1D2129' }}>
        <div
            className="football-field-text-scope"
            style={{
                position: 'absolute',
                top: '0',
                left: '0',
                width: '100%',
                height: '800px',
                // 足球场背景统一从 icon.js 获取，避免实时赛况和赛后详情场地图不一致。
                backgroundImage: `url(${Icon.FOOTBALL_FIELD_BACKGROUND})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                textAlign: 'center'
            }}
        >
            <div className="live-team-pitch-area">
                <div className="pitch-info-bar pitch-info-bar-top">
                    <div className="pitch-tag-group">
                        <span className="pitch-premium-tag">阵容: {getModelContent(gameDetail?.greenModel)}</span>
                    </div>
                    <div className="pitch-tag-group">
                        <span className="pitch-premium-tag">📊 {greenStats.age}岁 | {greenStats.grade}分</span>
                    </div>
                </div>
                <div className="live-pitch-lineup-stack">{greenLineup}</div>
            </div>

            <div className="live-team-pitch-area">
                <div className="live-pitch-lineup-stack">{redLineup}</div>
                <div className="pitch-info-bar pitch-info-bar-bottom">
                    <div className="pitch-tag-group">
                        <span className="pitch-premium-tag">阵容: {getModelContent(gameDetail?.redModel)}</span>
                    </div>
                    <div className="pitch-tag-group">
                        <span className="pitch-premium-tag">📊 {redStats.age}岁 | {redStats.grade}分</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
)

// 比赛操作入口保持为无状态组件，主页面只负责提供动作和处理函数。
export const PremiumActionGrid = ({ actions, onAction }) => (
    <div className="premium-action-grid">
        {actions.map((action) => (
            <div
                key={action.value}
                className={`premium-action-btn ${action.className || ''}`}
                onClick={() => onAction(action)}
            >
                <img src={action.icon} className="premium-action-icon" alt={action.label} />
                <span className="premium-action-label">{action.label}</span>
            </div>
        ))}
    </div>
)

// 请假分类自行管理展开状态，避免把纯展示状态堆积到比赛主页面。
export const LeaveCategory = ({ reason, groupMembers, gIndex, navigate, getMemberImage }) => {
    const [isExpanded, setIsExpanded] = useState(false)

    return (
        <div className={`leave-reason-group ${gIndex === 0 ? 'first' : ''}`}>
            <div
                className="leave-reason-header"
                onClick={() => setIsExpanded(!isExpanded)}
            >
                <div className="leave-reason-left">
                    <span className="leave-reason-text">{reason}</span>
                    <Badge content={groupMembers.length} color="#3b82f6" className="leave-reason-badge" />
                </div>
                <div className={`leave-category-chevron ${isExpanded ? 'rotated' : ''}`}>
                    <DownOutline fontSize={14} />
                </div>
            </div>

            <div className="leave-category-content">
                {isExpanded ? (
                    <div className="leave-items-list-detailed">
                        {groupMembers.map((user, index) => (
                            <div key={user.id || index} className="leave-item-row-detailed" onClick={() => navigate(`/members/${user.id}`)}>
                                <div className="leave-item-avatar-wrapper">
                                    <img src={getMemberImage(user)} className="leave-item-avatar-small" alt={user.name} />
                                </div>
                                <div className="leave-item-content">
                                    <div className="leave-item-name-row">
                                        <span className="leave-item-name-bold">{user.name}</span>
                                        <span className="leave-item-tag">详情</span>
                                    </div>
                                    <div className="leave-item-remark-text">{user.remark || '未填写具体原因'}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="leave-items-grid-compact">
                        <Grid columns={5} gap={10}>
                            {groupMembers.map((user, index) => (
                                <Grid.Item key={user.id || index} onClick={() => navigate(`/members/${user.id}`)}>
                                    <div className="leave-grid-item-compact">
                                        <img src={getMemberImage(user)} className="leave-grid-avatar-compact" alt={user.name} />
                                        <div className="leave-grid-name-compact">{user.name}</div>
                                    </div>
                                </Grid.Item>
                            ))}
                        </Grid>
                    </div>
                )}
            </div>
        </div>
    )
}
